export const FACEBOOK_EVENTS = {
	// Same name as the web app's paywall sends when a plan is picked
	ADD_TO_CART: 'AddToCart',
};
